export default "__VITE_ASSET__BjIDiZ77__"